module.exports = __webpack_public_path__ + "9b5b6e832b990e24515a5d1d5b446f5e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-7.png
// module id = 3333
// module chunks = 0